import {t} from './getTranslations';

export function openWindow({
  url,
  target,
  features = '',
  blockPopupText = '',
}: {
  url: string;
  target?: string;
  features?: string;
  blockPopupText?: string;
}) {
  // 브라우저마다 지원하는 option들이 다르다. (참고: https://www.w3schools.com/jsref/met_win_open.asp)
  const popupFeatures = `toolbar=no, directories=no, scrollbars=yes, resizable=no, status=no, menubar=no, location=no${
    features && ', '
  }${features}`;
  const popup = window.open(url, target, popupFeatures);
  if (!popup) {
    const title = t('alert_message_popup_blocked');
    const desc = `${t('alert_message_turn_off_popup_blocker')}${
      blockPopupText && `\n\n${blockPopupText}`
    }`;
    window.alert(`${title}\n\n${desc}`);
  }
  return popup;
}
